import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";

import { useLazyQuery } from "@apollo/client";

import MakeSelectionTick from "../../../assets/images/icons/makes_selection_tick.svg";
import "../../../styles/newStyles/makesTab.scss";
import { LIST_TAB_MAKES } from "../../NewQuery/EquipmentTab/equipmentQuery";
import * as HomePageTabsAction from "../../NewRedux/HomePageTabs/homepageTabsAction";

export const EquipmentStepper1 = ({ stepperState, setStepperState, setFilterSelectedData, filterSelectedData }) => {
  const dispatch = useDispatch();

  const makes = useSelector(state => state.homepageTabSlice.makes);

  const [columnCountState] = useState(4);

  const [data, setData] = useState([]);

  const [getTabMakesData,
    { loading: tabMakesDataLoading, error: tabMakesDataError, data: tabMakesData }] = useLazyQuery(LIST_TAB_MAKES, {
    fetchPolicy: "no-cache",
  });

  useEffect(() => {
    if (tabMakesData?.getMakeData.make) {
      dispatch(HomePageTabsAction.setTabMakesList(tabMakesData?.getMakeData.make));
    }
  }, [tabMakesDataLoading, tabMakesDataError, tabMakesData, dispatch]);
  useEffect(() => {
    getTabMakesData({
      variables: { categoryId: filterSelectedData.category[0].id },
    });
  }, [filterSelectedData]);

  const selectMakes = (filterName) => {
    let filteredSelectedBreadcrumbData = [...filterSelectedData.makes];
    let filterExist = filteredSelectedBreadcrumbData.some((filterValue) => filterValue.id === filterName.id);
    if (filterExist) {
      filteredSelectedBreadcrumbData = filteredSelectedBreadcrumbData.filter((value) => value.id !== filterName.id);
    }
    else {
      filteredSelectedBreadcrumbData.push(filterName);
    }

    setFilterSelectedData((preVal) => ({ ...preVal, makes: [...filteredSelectedBreadcrumbData] }));
  };

  useEffect(() => {
    if (tabMakesData?.getMakeData.make) {
      let dataArray = [];
      tabMakesData.getMakeData.make.map((next, index) => {
        let localArray = [];
        let indexVar = null;
        switch (index % columnCountState) {
        case 0:
          indexVar = 0;
          break;
        case 1:
          indexVar = 1;
          break;
        case 2:
          indexVar = 2;
          break;
        default:
          indexVar = 3;
        }

        if (Array.isArray(dataArray[indexVar])) {
          dataArray[indexVar].push(
            <div className="makesContentUpperDivision"><div className="d-flex justify-content-center align-items-center contentUpperDivision" onClick={() => selectMakes(next)}>{next.name}</div>
              {
                filterSelectedData.makes.some((value) => value.id === next.id) ? <img src={MakeSelectionTick} className={"makeSelectionTickImage"} /> : null
              }

            </div>,
          );
        }
        else {
          localArray.push(
            <div className="makesContentUpperDivision">
              <div className="d-flex justify-content-center align-items-center contentUpperDivision" onClick={() => selectMakes(next)}>{next.name}</div>
              {
                filterSelectedData.makes.some((value) => value.id === next.id) ? <img src={MakeSelectionTick} className={"makeSelectionTickImage"} /> : null
              }
            </div>,
          );
          dataArray.push(localArray);
        }
      });
      setData(dataArray);
    }

  }, [filterSelectedData.makes, tabMakesData]);

  const showModels = () => {
    setStepperState(2);
  };

  return (
    <div id="makesSelectionDivision" className="makesSelectionDivision">
      <div id="makesUpperDivision" className="d-flex justify-content-around mb-5 row">
        <Link to="/search-result" className="viewAllMakesButton">View All Makes</Link>
        {
          filterSelectedData.makes.length ? <button className="selectModelsMakesButton" onClick={() => showModels()}>Select Models</button> : null
        }
      </div>
      <div className="makeTabDividerDivision text-center my-5">
        OR
      </div>
      <div id="makesLowerDivision">
        <div className="makesLowerTopDivision mb-5">
          <div className="text-center makeBottomDivisionTitle">
            {filterSelectedData.category[0].name}
          </div>
          <div className="text-center makeBottomDivisionSubtitle row">
            <div className="col-3"></div>
            <div className="col-6 text-center">
              Select a make(s) below to continue
            </div>
            {
              filterSelectedData.makes.length ? <div className="col-3 d-flex justify-content-end makesSelectedCountDivision">
                {
                  filterSelectedData.makes.length
                } Makes Selected
              </div> : null
            }

          </div>
        </div>
        <div className="d-flex flex-wrap">
          {
            data.length ? data.map((value, index) => {
              return (
                value.map((innerArrayValue) => {
                  return (
                    innerArrayValue
                  );
                })
              );
            }) : null
          }
        </div>
      </div>
    </div>
  );
};
